





















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import RouterHelper from '../../helpers/router.helper';
import { EModes } from '../../models/Enums/EModes';

const routerHelper = new RouterHelper();

@Component
export default class LoginDefaultLayout extends Vue {
  @Prop({ default: EModes.Parents })
  private readonly mode?: string;

  @Prop({ default: '' })
  private readonly title?: string;

  @Prop({ required: false, default: false })
  private readonly isSignUp?: boolean;

  @Prop({ required: false, default: false })
  private readonly isLogIn?: boolean;

  @Prop({ required: false, default: false })
  private readonly isForgotPassword?: boolean;

  @Prop({ required: false, default: 0 })
  private readonly progress?: number;

  public images = {
    [EModes.Students]: {
      src: () => require('../../assets/students.svg'),
      class: 'purple',
      'max-width': '111%',
    },
    [EModes.Parents]: {
      src: () => require('../../assets/family_2.svg'),
      class: 'purple',
      'max-width': '111%',
    },
    [EModes.Organization]: {
      src: () => require('../../assets/Organization.svg'),
      class: 'indigoDarken',
      'max-width': '95%',
    },
  };

  public modes = EModes;

  login() {
    this.$router.push(routerHelper.login().getRoute());
  }

  signup() {
    this.$router.push(routerHelper.signup().getRoute());
  }

  forgotPassword() {
    this.$router.push(routerHelper.signup().forgotPassword().getRoute());
  }
}
